/**
 * PayPal integration API endpoints
 */
import { apiGet, apiPost } from "./client.js";

/**
 * Fetches PayPal configuration including client ID
 * @returns {Promise<Response>} PayPal config response
 */
export const getPaypalConfig = () => apiGet("/paypal-plugin/config");

/**
 * Creates a PayPal order
 * @param {Object} orderData - Order data including items, total, and shipping preference
 * @returns {Promise<Response>} PayPal order creation response
 */
export const createPaypalOrder = (orderData) =>
  apiPost("/paypal-plugin/create-order", orderData, { includeSessionToken: true });

/**
 * Captures a PayPal order after approval
 * @param {string} orderID - PayPal order ID to capture
 * @returns {Promise<Response>} PayPal capture response
 */
export const capturePaypalOrder = (orderID) =>
  apiPost("/paypal-plugin/capture-order", { orderID }, { includeSessionToken: true });
